import { useMemo } from "react";
import * as React from "react";
import styled from "styled-components";
import { Select, Icon, InputDescription } from "components/common";
import { FormGroup, ControlLabel } from "components/bootstrap";
import { defaultCompare } from "logic/DefaultCompare";
import streamCategoryName from "logic/streams/streamCategoryName";
const StyledFormGroup = styled(FormGroup)`
  margin-bottom: 0;
`;
const StyledIcon = styled(Icon)`
  width: 24px;
  vertical-align: middle;
`;
const renderOption = (option) => option.value.type === "stream" ? /* @__PURE__ */ React.createElement(React.Fragment, null, option.label) : /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledIcon, { name: "stacks", size: "xs" }), option.label);
const StreamsAndCategoriesFilter = ({
  id,
  onChange,
  streams,
  value = void 0,
  streamCategories = void 0,
  required = true,
  showStreams = true,
  showCategories = true,
  grouping = true,
  multi = true,
  label = void 0,
  error = void 0,
  help = void 0,
  ...rest
}) => {
  var _a, _b;
  const options = useMemo(() => {
    const sortedCategories = showCategories && multi ? [...new Set(streams.flatMap((stream) => {
      var _a2;
      return (_a2 = streamCategories != null ? streamCategories : stream == null ? void 0 : stream.categories) != null ? _a2 : [];
    }))].map((category) => ({
      label: streamCategoryName(category),
      value: { id: category, type: "category" }
    })).sort((a, b) => defaultCompare(a.label, b.label)) : [];
    const sortedStreams = showStreams ? streams.map((stream) => ({
      label: stream.title,
      value: { id: stream.id, type: "stream" }
    })).sort((a, b) => defaultCompare(a.label, b.label)) : [];
    return grouping ? [...sortedCategories, ...sortedStreams] : [...sortedCategories, ...sortedStreams].sort(
      (a, b) => defaultCompare(a.label, b.label)
    );
  }, [grouping, multi, showCategories, showStreams, streams, streamCategories]);
  if (!options || options.length === 0) return null;
  const selectedOptions = options.filter(
    (o) => {
      var _a2, _b2;
      return o.value.type === "stream" && ((_a2 = value == null ? void 0 : value.streams) == null ? void 0 : _a2.includes(o.value.id)) || o.value.type === "category" && ((_b2 = value == null ? void 0 : value.categories) == null ? void 0 : _b2.includes(o.value.id));
    }
  );
  const handleReactSelectChange = (selected) => {
    const selectedArray = Array.isArray(selected) ? selected : selected ? [selected] : [];
    onChange({
      streams: selectedArray.filter((o) => o.value.type === "stream").map((o) => o.value.id),
      categories: selectedArray.filter((o) => o.value.type === "category").map((o) => o.value.id)
    });
  };
  return /* @__PURE__ */ React.createElement(StyledFormGroup, { controlId: (_a = rest.inputId) != null ? _a : id, validationState: error ? "error" : null }, label && /* @__PURE__ */ React.createElement(ControlLabel, null, label), /* @__PURE__ */ React.createElement(
    Select,
    {
      ...rest,
      id,
      inputId: (_b = rest.inputId) != null ? _b : id,
      onChange: () => {
      },
      onReactSelectChange: handleReactSelectChange,
      options,
      optionRenderer: renderOption,
      valueRenderer: renderOption,
      value: selectedOptions,
      required,
      multi
    }
  ), /* @__PURE__ */ React.createElement(InputDescription, { error, help }));
};
export default StreamsAndCategoriesFilter;
